import React from "react";
import {
  Download, BookOpen, Map, Youtube, Wrench, Mail, Instagram, Music2,
  Percent, Tag, Compass, Plane, Wallet, Globe, ExternalLink, ShoppingBag,
  CreditCard, Star, Gift, Video, Ticket, Heart,
} from "lucide-react";

// Simple brand SVGs for platforms not in lucide
export const TikTokIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden><path d="M16.5 3c.4 2.1 1.7 3.7 3.9 3.9v2.4c-1.4.1-2.7-.3-3.9-1v6.3c0 3.2-2.6 5.4-5.5 5.4A5.4 5.4 0 0 1 5.5 14a5.4 5.4 0 0 1 6.4-5.3v2.5a2.9 2.9 0 0 0-3.9 2.8 2.9 2.9 0 0 0 5.8.1V3h2.7z"/></svg>
);
export const PinterestIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden><path d="M12 2a10 10 0 0 0-3.6 19.3c-.1-.8-.2-2 0-2.9l1.2-5s-.3-.6-.3-1.5c0-1.4.8-2.4 1.8-2.4.9 0 1.3.6 1.3 1.4 0 .9-.6 2.2-.9 3.4-.2 1 .5 1.8 1.5 1.8 1.8 0 3.1-2.3 3.1-5 0-2.1-1.4-3.6-3.9-3.6-2.9 0-4.6 2.1-4.6 4.4 0 .9.3 1.5.8 2 .1.1.1.2.1.3l-.3 1.1c0 .2-.2.2-.3.1-1-.4-1.5-1.6-1.5-2.9 0-2.2 1.8-4.8 5.5-4.8 3 0 4.9 2.1 4.9 4.4 0 3-1.7 5.3-4.2 5.3-.8 0-1.6-.5-1.9-1l-.5 2c-.2.7-.6 1.5-1 2A10 10 0 1 0 12 2z"/></svg>
);
export const ThreadsIcon = ({ className = "" }) => (
  <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden><path d="M12.2 2c-4.9 0-8 2.9-8.1 8-.1 5 2.9 8 8 8 2.7 0 4.6-.9 5.9-2.6l-1.7-1.2c-.9 1.2-2.2 1.8-4.2 1.8-3.3 0-5.1-1.9-5.1-6 0-4 1.8-6 5.2-6 2.9 0 4.5 1.4 4.9 3.9-1-.4-2.1-.6-3.4-.6-3 0-4.8 1.4-4.8 3.6 0 2 1.7 3.3 3.9 3.3 2.7 0 4.3-1.8 4.3-4.9V10c0-.1 0-.1 0 0 0-.1 0-.2 0-.3C21 5.3 18.4 2 12.2 2zm.4 10.8c-1.2 0-2-.5-2-1.4 0-1 .9-1.5 2.5-1.5 1 0 1.9.2 2.6.5-.1 1.6-1.1 2.4-3.1 2.4z"/></svg>
);

export const BIO_ICONS = {
  download: { label: "Download", Comp: Download },
  guide: { label: "Guida", Comp: BookOpen },
  map: { label: "Mappa", Comp: Map },
  itinerary: { label: "Itinerario", Comp: Map },
  youtube: { label: "YouTube", Comp: Youtube },
  resources: { label: "Risorse", Comp: Wrench },
  newsletter: { label: "Newsletter", Comp: Mail },
  instagram: { label: "Instagram", Comp: Instagram },
  tiktok: { label: "TikTok", Comp: TikTokIcon },
  pinterest: { label: "Pinterest", Comp: PinterestIcon },
  threads: { label: "Threads", Comp: ThreadsIcon },
  affiliate: { label: "Affiliati", Comp: Percent },
  offer: { label: "Offerta", Comp: Tag },
  tools: { label: "Strumenti", Comp: Compass },
  booking: { label: "Prenota", Comp: Plane },
  wallet: { label: "Wallet", Comp: Wallet },
  globe: { label: "Web", Comp: Globe },
  link: { label: "Link", Comp: ExternalLink },
  shop: { label: "Shop", Comp: ShoppingBag },
  card: { label: "Carta", Comp: CreditCard },
  star: { label: "Stella", Comp: Star },
  gift: { label: "Regalo", Comp: Gift },
  video: { label: "Video", Comp: Video },
  ticket: { label: "Biglietto", Comp: Ticket },
  heart: { label: "Cuore", Comp: Heart },
};

export function BioIcon({ name, className }) {
  const entry = BIO_ICONS[name] || BIO_ICONS.link;
  const C = entry.Comp;
  return <C className={className} />;
}

export const BIO_COLORS = {
  orange: { label: "Arancione", cls: "bg-vs-orange text-white", icon: "text-white" },
  green: { label: "Verde", cls: "bg-vs-green text-white", icon: "text-white" },
  dark: { label: "Scuro", cls: "bg-vs-text text-white", icon: "text-white" },
  peach: { label: "Pesca", cls: "bg-vs-peach text-vs-text", icon: "text-vs-orangeDark" },
  mint: { label: "Verde chiaro", cls: "bg-vs-mint text-vs-text", icon: "text-vs-green" },
  white: { label: "Bianco", cls: "bg-white text-vs-text border border-vs-text/10", icon: "text-vs-green" },
};

export const SOCIAL_PLATFORMS = [
  { key: "instagram", label: "Instagram" },
  { key: "tiktok", label: "TikTok" },
  { key: "youtube", label: "YouTube" },
  { key: "pinterest", label: "Pinterest" },
  { key: "threads", label: "Threads" },
];

// Returns true if a button should be visible now (enabled + within schedule window)
export function isButtonLive(btn, now = new Date()) {
  if (btn.enabled === false) return false;
  if (btn.start_at) { try { if (now < new Date(btn.start_at)) return false; } catch (e) {} }
  if (btn.end_at) { try { if (now > new Date(btn.end_at)) return false; } catch (e) {} }
  return true;
}
